
const apiConfig = {
    //apiUrl: 'https://localhost:7278/api/',
    apiUrl: 'https://abk-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

